/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePayJunctionKeyResponse } from './CreatePayJunctionKeyResponse';
import {
    CreatePayJunctionKeyResponseFromJSON,
    CreatePayJunctionKeyResponseFromJSONTyped,
    CreatePayJunctionKeyResponseToJSON,
    CreatePayJunctionKeyResponseToJSONTyped,
} from './CreatePayJunctionKeyResponse';

/**
 * 
 * @export
 * @interface ResultOfCreatePayJunctionKeyResponse
 */
export interface ResultOfCreatePayJunctionKeyResponse {
    /**
     * 
     * @type {CreatePayJunctionKeyResponse}
     * @memberof ResultOfCreatePayJunctionKeyResponse
     */
    data: CreatePayJunctionKeyResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreatePayJunctionKeyResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreatePayJunctionKeyResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreatePayJunctionKeyResponse interface.
 */
export function instanceOfResultOfCreatePayJunctionKeyResponse(value: object): value is ResultOfCreatePayJunctionKeyResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreatePayJunctionKeyResponseFromJSON(json: any): ResultOfCreatePayJunctionKeyResponse {
    return ResultOfCreatePayJunctionKeyResponseFromJSONTyped(json, false);
}

export function ResultOfCreatePayJunctionKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreatePayJunctionKeyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreatePayJunctionKeyResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreatePayJunctionKeyResponseToJSON(json: any): ResultOfCreatePayJunctionKeyResponse {
    return ResultOfCreatePayJunctionKeyResponseToJSONTyped(json, false);
}

export function ResultOfCreatePayJunctionKeyResponseToJSONTyped(value?: ResultOfCreatePayJunctionKeyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreatePayJunctionKeyResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

